import React, {useContext, useState, useId} from 'react'
import {Badge, Collapse, Divider} from "antd";
import {
    ChevronRightRounded,
    FilterListRounded
} from "@mui/icons-material";
import {BrandContext} from "./BrandContext";
import Button from "./Button";
import {TemplateContext} from "./TemplateContext";

// NOTE: This component is a WIP and subject to change.

const TableFilterControls = ({ primaryFilterItem, startOpen = true, filterContent, showFilterButton, showFilterIcon = true, filterCount = 0, filterButtonHeading = 'Filter' }) => {
    const brandConfig = useContext(BrandContext);
    const {bodyComponentName} = useContext(TemplateContext);
    const id = useId()

    const isUSAWithAllowedComponent = brandConfig.brandCode === 'USA' &&
        bodyComponentName !== 'SchoolManagementTabs' &&
        bodyComponentName !== 'Reports';

    const [activeKey, setActiveKey] = useState((isUSAWithAllowedComponent || !startOpen) ? null : '1');
    const [isOpen, setOpen] = useState((!isUSAWithAllowedComponent && startOpen));

    const handleButtonClick = () => {
        if(activeKey) {
            setActiveKey(null);
            setOpen(false);
        } else {
            setActiveKey("1");
            setOpen(true);
        }
    };

    const filterItems = [
        {
            key: '1',
            label: 'Filter',
            children: (
                <div id={"filter-content"+id} role="region" aria-labelledby={isUSAWithAllowedComponent || showFilterButton ? "filter-button"+id : ''}>
                    {filterContent}
                </div>
            ),
        }
    ]

    return(
        <>
            <div style={{display: 'flex'}}>
                {primaryFilterItem && primaryFilterItem}
                {(primaryFilterItem && showFilterButton) &&
                    <Divider type={'vertical'} style={{height: 'auto'}} />
                }
                {((brandConfig.brandCode === 'USA' && bodyComponentName !== 'SchoolManagementTabs' && bodyComponentName !== 'Reports') || showFilterButton) &&
                    <Button
                        id={'filter-button'+id}
                        className={'margin--s'}
                        aria-controls={'filter-content'+id}
                        aria-expanded={isOpen}
                        type={'outline'}
                        onClick={handleButtonClick}
                    >
                        <span className={'ch-filter-form-button-content'}>
                            {showFilterIcon && <FilterListRounded />}
                            {filterButtonHeading}
                            {filterCount ? <Badge title={''} count={filterCount} style={{backgroundColor: 'var(--icon-colour)'}} /> : null}
                            <ChevronRightRounded
                                style={{
                                    transform: isOpen ? 'rotate(270deg)' : 'rotate(90deg)',
                                    transition:'var(--ani-mid) ease'}}
                            />
                        </span>
                    </Button>
                }
            </div>
            <Collapse activeKey={activeKey} accordion ghost items={filterItems} size={"small"} className={'ch-table-filter-collapse-nostyle'} />
        </>
    )
}

export default TableFilterControls;